import React, { useState } from "react";
import {ToggleButtonGroup, ToggleButton, OverlayTrigger, Tooltip } from "react-bootstrap";
import moment from "moment";

export default function DateRangePicker({range, setRange, timeSpan, boxStyle = "border rounded p-3 bg-light"}) {
    const [rangeType, setRangeType] = useState("absolute");
    const relativeOptions = [
        { type: "Minut"   , unit: "minutes" , amount: [1, 3, 5, 15, 30, 45 ] },
        { type: "Godzin"  , unit: "hours"   , amount: [1, 2, 3, 6, 8, 12 ] },
        { type: "Dni"     , unit: "days"    , amount: [1, 2, 3, 4, 5, 6 ] },
        { type: "Tygodni" , unit: "weeks"   , amount: [1, 2, 3, 4, 5, 6 ] },
        { type: "Miesięcy", unit: "months"  , amount: [1, 3, 4, 6, 12, 15 ] },
    ];
    const periodicOptions = [
        { type: "Godzin"  , unit: "hours"   , amount: [1, 2, 3, 6, 8, 12 ] },
        { type: "Dni"     , unit: "days"    , amount: [1, 2, 3, 4, 5, 6 ] },
        { type: "Tygodni" , unit: "weeks"   , amount: [1, 2, 3, 4, 5, 6 ] },
        { type: "Miesięcy", unit: "months"  , amount: [1, 3, 4, 6, 12, 15 ] },
    ];

    const [relativeOption, setRelativeOption] = useState(`days-1`)
    const [periodicOption, setPeriodicOption] = useState(`days-1`)

    const handleRangeTypeSelect = (val) => {
        setRangeType(val)
        if (val === "periodic") handlePeriodicSelect(`days-1`)
        if (val === "relative") handleRelativeSelect('days-1')   
    }

    const handleRelativeSelect = (val) => {
        setRelativeOption(val);
        const [ unit, amount ] = val.split(`-`);
        setRange({
            start: moment().subtract(amount, unit).format("YYYY-MM-DDTHH:mm:ss"),
            end: moment().format("YYYY-MM-DDTHH:mm:ss"),
        });

    };
    const handlePeriodicSelect = (val) => {
        setPeriodicOption(val);
        const [ unit, amount ] = val.split(`-`);
        const end = moment().startOf(unit);
        const start = end.clone().subtract(Number(amount), unit);
        setRange({
            start: start.format("YYYY-MM-DDTHH:mm:ss"),
            end: moment(end).subtract(1, "second").format("YYYY-MM-DDTHH:mm:ss")
        })
    };
    const handleAbsoluteChange = (key, value) => {
        setRange((prev) => ({ ...prev, [key]: value }));
    };

  return (
    <div className={boxStyle}>
        <div>
            <div><h6 className="d-flex justify-content-center ml-4">Zakres czasu
                <OverlayTrigger placement="bottom" overlay={
                    <Tooltip id="tooltip">
                        Tryb Absolutny: <br/>Standardowy wybór daty/czasu od/do. <br/><br/>
                        Tryb Relatywny: <br/>Zakres czasu liczony względem bieżącej daty/czasu (np. ostatni tydzień, ostatni miesiąc, ostatnie 3 godziny). <br/><br/>
                        Tryb Okresowy: <br/>Zakres czasu liczony względem bieżącej daty/czasu obejmujący ostatni pełny okres (np. ostatni pełny tydzień, ostatni pełny miesiąc) liczony od/do północy.
                    </Tooltip>}>
                 <i className="fas fa-info-circle text-secondary ml-2" style={{ fontSize: "20px", cursor: "pointer"}}/>
                </OverlayTrigger>
            </h6> 
                <div className="d-flex justify-content-center" style={{ fontVariantNumeric: "tabular-nums", fontSize: "14px"}}>
                    {moment(range.start).format("YYYY-MM-DD HH:mm:ss")}
                    {[3, 18].includes(timeSpan) && (<> —{" "}{moment(range.end).format("YYYY-MM-DD HH:mm:ss")}</>)}
                    {[2].includes(timeSpan) && (<> —{" "}teraz</>)}</div>
            </div>
            <div className="d-flex justify-content-center" style={{position: "relative"}}>
                <ToggleButtonGroup type="radio" name="rangeType" value={rangeType} onChange={(val) => handleRangeTypeSelect(val)} className="toggle-group-sm rounded-pill bg-light overflow-hidden toggle-group border border-primary">
                    <ToggleButton id="tbg-radio-1" value ="absolute" variant="outline-primary" className="btn-sm border-0 m-1 rounded-pill" title="Standardowy wybór daty/czasu od/do. ">
                        Absolutny
                    </ToggleButton>
                    <ToggleButton id="tbg-radio-2" value ="relative" variant="outline-primary" className="btn-sm border-0 m-1 rounded-pill" title="Zakres czasu liczony względem bieżącej daty/czasu (np. ostatni tydzień, ostatni miesiąc, ostatnie 3 godziny). ">
                        Relatywny
                    </ToggleButton>
                    <ToggleButton id="tbg-radio-3" value ="periodic" variant="outline-primary" className="btn-sm border-0 m-1 rounded-pill" title="Zakres czasu liczony względem bieżącej daty/czasu obejmujący ostatni pełny okres (np. ostatni pełny tydzień, ostatni pełny miesiąc) liczony od/do północy.">
                        Okresowy
                    </ToggleButton>
                </ToggleButtonGroup>
            </div>
        </div>
    {rangeType === "absolute" && (
        <div className="d-flex flex-column gap-2 mt-2">
            <div className="d-flex flex-row align-items-center mb-2">
                <label className="form-label small mb-0 mr-2">Od</label>
                <input 
                    type="datetime-local"
                    step="1"
                    max="2050-12-31T23:59:59"
                    className="form-control form-control-sm" 
                    value={range.start} 
                    onChange={(e) => handleAbsoluteChange("start", e.target.value)}
                />
            </div>
            {[3, 18].includes(timeSpan) && (
            <div className="d-flex flex-row align-items-center">
                <label className="form-label small mb-0 mr-2">Do</label>
                <input
                    type="datetime-local"
                    step="1"
                    max="2050-12-31T23:59:59"
                    className="form-control form-control-sm"
                    value={range.end}
                    onChange={(e) => handleAbsoluteChange("end", e.target.value)}
                />
            </div>
            )}
        </div>
    )}
    {rangeType === "relative" && (
        <div>
            {relativeOptions.map((opt) => (
            <div key={opt.unit} className="row align-items-center">
                <div className="col-3">{opt.type}</div>
                <div className="d-flex col-9 flex-wrap gap-2 justify-content-end">
                    <ToggleButtonGroup type="radio" name="relativeOptions" value={relativeOption} onChange={(val) => handleRelativeSelect(val)} className="toggle-group toggle-group-sm rounded-pill bg-light overflow-hidden border border-dark mt-1">
                        {opt.amount.map((i) => (
                            <ToggleButton key={`${opt.unit}-${i}`} id={`tbg-${opt.unit}-${i}`} value={`${opt.unit}-${i}`} variant="outline-dark" className="btn-sm border-0 m-1 p-0 rounded-pill" style={{ width: "30px", height: "20px", justifyContent: "center"}}>
                                {i}
                            </ToggleButton>
                        ))}
                    </ToggleButtonGroup>
                </div>
            </div>
            ))}
        </div>
    )}
    {rangeType === "periodic" && (
        <div>
            {periodicOptions.map((opt) => (
            <div key={opt.unit} className="row align-items-center">
                <div className="col-3">{opt.type}</div>
                <div className="d-flex col-9 flex-wrap gap-2 justify-content-end">
                    <ToggleButtonGroup type="radio" name="periodicOptions" value={periodicOption} onChange={(val) => handlePeriodicSelect(val)} className="toggle-group toggle-group-sm rounded-pill bg-light overflow-hidden border border-dark mt-1">
                        {opt.amount.map((i) => (
                            <ToggleButton key={`${opt.unit}-${i}`} id={`tbg-${opt.unit}-${i}`} value={`${opt.unit}-${i}`} variant="outline-primary" className="btn-sm border-0 m-1 p-0 rounded-pill" style={{ width: "30px", height: "20px", justifyContent: "center"}}>
                                {i}
                            </ToggleButton>
                        ))}
                    </ToggleButtonGroup>
                </div>
            </div>
            ))}
        </div>
    )}
    </div>
  );
}
